import { render } from "./ModelCard.vue?vue&type=template&id=6eee0506&scoped=true&ts=true"
import script from "./ModelCard.vue?vue&type=script&lang=ts"
export * from "./ModelCard.vue?vue&type=script&lang=ts"

import "./ModelCard.vue?vue&type=style&index=0&id=6eee0506&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eee0506"]])

export default __exports__